"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapAnchor = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.MapAnchor = styled_1.default.a `
  display: inline-block;
  cursor: pointer;

  &,
  &:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
    text-decoration: none;
  }

  &:hover,
  &:hover:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link_hover')};
    text-decoration: underline;
  }
`;
//# sourceMappingURL=MapLink.styles.js.map